import React, { useEffect, useMemo, useState } from 'react';

import { Autocomplete, Box, TextField } from '@mui/material';

import { townCodes, TownCode } from '../../../core/src/shared/town-codes';
import { useDispatch, useSelector } from '../store/utils';
import { variablesChange } from '../store/actions';

const defaultValue = townCodes.slice(0, 10);

export const TownCodeSelect = () => {
  const dispatch = useDispatch();
  const townCode = useSelector((s) => s.variables.TOWN_CODE);

  const [inputValue, setInputValue] = useState('');
  const [options, setOptions] = useState(defaultValue);

  const value = useMemo(() => {
    return townCodes.find((option) => option.townCode === townCode);
  }, [townCode]);

  useEffect(() => {
    if (inputValue.length < 3) setOptions(defaultValue);

    const searchedOptions = townCodes
      .filter((option) => {
        return option.town.toLowerCase().includes(inputValue.toLowerCase());
      })
      .slice(0, 50);

    setOptions(searchedOptions);
  }, [inputValue]);

  const opts = useMemo(() => {
    const valueIsInOptions = options.some(
      (option) => option.townCode === townCode
    );
    if (value && !valueIsInOptions) {
      return [value, ...options];
    }

    return options;
  }, [value, options]);

  return (
    <Autocomplete
      value={value}
      sx={{ width: 300 }}
      options={opts}
      autoHighlight
      getOptionLabel={(option) => getOptionLabel(option)}
      filterOptions={(x) => x}
      isOptionEqualToValue={(option, value) =>
        option.townCode === value.townCode
      }
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <Box key={key} component="li" {...optionProps}>
            {getOptionLabel(option)}
          </Box>
        );
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField {...params} label="Obec" size="small" />
      )}
      onChange={(_, value) => {
        if (value) dispatch(variablesChange({ TOWN_CODE: value.townCode }));
      }}
    />
  );
};

function getOptionLabel({ town, district }: TownCode) {
  return `${town}${town !== district ? ` (okr. ${district})` : ''}`;
}
